import { Children } from 'react';
import { useTechnologyCards } from 'libs/consumer/components/src/lib/TechnologyCards/useTechnologyCards';
import ConsumerTechCard from './ConsumerTechCard/consumerTechCard';
import { purifyTextWithLogo, requireStaticImageAtomComponent } from '@vfit/shared/data-access';
import { Player } from '@lottiefiles/react-lottie-player';
import { Shadow } from '@vfit/shared/atoms';
import { I_ConsumerTechnologyCardProps } from './consumerTechnologyCard.models';
import {
  ConsumerTechCardWrapper,
  TechnologyCardTitle,
  TechnologyCardTitleWrapper,
  TechnologyCardWrapper,
} from './consumerTechnologyCard.style';
import ConsumerVodafoneModal from '../ConsumerVodafoneModal/consumerVodafoneModal';
import DOMPurify from 'isomorphic-dompurify';

const ConsumerTechnologyCard = ({
  isLoading,
  titleOfTechnologyCard,
  lottie,
}: I_ConsumerTechnologyCardProps) => {
  const { techCard, info, techModal, handleCloseModal, showDetail } = useTechnologyCards();
  const sanitizeText = DOMPurify.sanitize(titleOfTechnologyCard, { ADD_ATTR: ['target'] });

  const purifiedTitle = purifyTextWithLogo(sanitizeText);

  return (
    <TechnologyCardWrapper>
      {titleOfTechnologyCard && techCard?.length > 0 && (
        <>
          {isLoading ? (
            <div>
              {lottie ? (
                <Player
                  src={requireStaticImageAtomComponent(lottie).src}
                  className="player"
                  loop
                  autoplay
                />
              ) : (
                <Shadow height={70} />
              )}
            </div>
          ) : (
            <TechnologyCardTitleWrapper>
              <TechnologyCardTitle dangerouslySetInnerHTML={{ __html: purifiedTitle }} />
            </TechnologyCardTitleWrapper>
          )}
        </>
      )}
      <ConsumerTechCardWrapper>
        {Children.toArray(
          techCard.length > 0 &&
            techCard?.map((product) => (
              <ConsumerTechCard
                key={product?.id}
                techCard={product}
                onDetail={() => showDetail(product)}
                download={info?.download}
                upload={info?.upload}
                latency={info?.latency}
              />
            )),
        )}
        {techModal?.show && techModal?.component && (
          <ConsumerVodafoneModal
            isModalShown={techModal?.show}
            onCloseModal={handleCloseModal}
            tabletMode={techModal?.tabletMode}
            height={techModal?.containerHeight}
          >
            {techModal?.component}
          </ConsumerVodafoneModal>
        )}
      </ConsumerTechCardWrapper>
    </TechnologyCardWrapper>
  );
};

export default ConsumerTechnologyCard;

